import { Outlet } from "react-router-dom";
import { Header } from "./header";
import { Footer } from "./footer";
import { SkipLink } from "./skip-link";

export function Layout() {
  return (
    <div className="flex min-h-screen flex-col font-sans text-text-body bg-white">
      <SkipLink />
      <Header />
      <main id="main-content" className="flex-1 focus:outline-none" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
